import Bowser from "bowser";

const bowser = Bowser.parse(window.navigator.userAgent);

let isMobile = bowser.platform.type !== "desktop";

// read from params if we should force the desktop experience
const forceDesktop = new URLSearchParams(window.location.search).get(
  "forceDesktop"
);
if (forceDesktop) {
  isMobile = false;
}

export default isMobile;
